export { default as ProductPhoto } from "./ProductPhoto";
